var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m906 724.8 246-202.8c34.801-28.801 16.801-85.199-28.801-87.602l-316.8-19.199c-19.199-1.1992-36-13.199-43.199-31.199l-116.4-297.6c-16.801-42-75.602-42-92.398 0l-116.4 296.4c-7.1992 18-24 30-43.199 31.199l-318 19.203c-45.602 2.4023-63.602 58.801-28.801 87.602l246 201.6c14.398 12 21.602 32.398 16.801 50.398l-80.398 308.4c-10.801 43.199 36 78 74.398 54l267.6-171.6c16.801-10.801 37.199-10.801 52.801 0l268.8 171.6c38.398 24 85.199-10.801 74.398-54l-80.398-307.2c-3.6055-18 2.3945-37.199 17.996-49.199z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.87cc6ea0a225d499ae1e881476450344.svg";
export { ForwardRef as ReactComponent };